import type { Ticket as GQLOSTicket } from '@/generated/graphql';
import { take } from '@/helpers/takePayload';

export type OfferSheetTicket = {
  id?: number;
  gross?: number;
  name?: string;
  price?: number;
  projected?: number;
  section?: string;
};

export const fromGql = (item?: GQLOSTicket): OfferSheetTicket => ({
  ...take<OfferSheetTicket>(item || {}, 'id', 'gross', 'name', 'price', 'projected', 'section'),
});
